import(/* webpackMode: "eager" */ "/opt/build/repo/app/vad-ar-enrumsventilation/problem-losningar/page.tsx");
